(function () {
  if (window.shopbroProductVideoPlacement) return;
  window.shopbroProductVideoPlacement = true;
  var desktop = window.matchMedia('(min-width: 990px)');
  var states = new WeakMap();

  function init(root) {
    if (states.has(root)) return states.get(root);
    var video = root.querySelector('.product-youtube-block');
    var slot = root.querySelector('[data-shopbro-product-video-desktop-slot]');
    if (!video || !slot) return null;
    // A stable home marker lets the same player return without losing playback.
    var home = document.createComment('shopbro product video mobile home');
    video.parentNode.insertBefore(home, video);
    var state = { video: video, slot: slot, home: home };
    states.set(root, state);
    return state;
  }

  function place() {
    document.querySelectorAll('product-info').forEach(function (root) {
      var state = init(root);
      if (!state || !state.home.isConnected) return;
      if (desktop.matches) {
        if (state.video.parentNode !== state.slot) state.slot.appendChild(state.video);
      } else if (state.video.previousSibling !== state.home) {
        state.home.parentNode.insertBefore(state.video, state.home.nextSibling);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place, { once: true });
  else place();
  if (desktop.addEventListener) desktop.addEventListener('change', place);
  else desktop.addListener(place);
  document.addEventListener('shopify:section:load', place);
})();
